<style scoped>
/* #app {
  min-width: 1200px;
  padding-top: 80px;
} */
</style>
<template>
  <div id="app">
    <!-- <hearder></hearder> -->
    <router-view />
    <!-- <introduce></introduce>
    <backToTop></backToTop>
    <videoBox></videoBox> -->
  </div>
</template>
<script>
// import hearder from "@/components/hearder.vue"
// import introduce from "@/components/introduce.vue"
// import backToTop from "@/components/backToTop.vue"
// import videoBox from "@/components/videoBox.vue"
// 引入
import './assets/js/buriedPoint.js'
import './assets/js/fixible.js'
export default {
  name: 'App',
  components: {
  //  hearder,
  //  introduce,
  //  backToTop,
  //  videoBox
  },
   mounted () {
        const isPcFn = this.isPC();
        if(!isPcFn){
          this.$router.push("/wapHome");
        }
  },
  methods:{
    isPC(){
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
                  "SymbianOS", "Windows Phone",
                  "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
              flag = false;
              break;
          }
      }
      return flag;
      }
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue